(function() {
  'use strict';

  var PICKER_SELECTOR = '#x-vzj023ty';
  var BUY_BUTTON_SELECTOR = '#x-l2jy3fud';

  // Shared price map — built once, used by dropdowns + pricing engine
  var individualPrices = {};

  var OPTION_BADGES = {
    'M+F 5L':  { text: 'BEST SELLER', type: 'seller' },
    'M+F 20L': { text: 'BEST VALUE',  type: 'value' }
  };

  var PRODUCT_LABELS = {
    'M+F': 'Microbes + Feeder',
    'Kelp': 'Kelp',
    'Compost': 'Compost'
  };

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function buildIndividualPrices() {
    var picker = document.querySelector(PICKER_SELECTOR);
    if (!picker) return;

    var jsonScript = picker.querySelector('script[type="application/json"]');
    if (!jsonScript) return;

    var variants;
    try { variants = JSON.parse(jsonScript.textContent); } catch(e) { return; }
    if (!variants || !variants.length) return;

    var fields = Array.from(picker.querySelectorAll('.x-variant-picker__input'));
    var optionCount = fields.length;

    variants.forEach(function(v) {
      var opts = v.options;
      var skipCount = 0;
      var activeIndex = -1;
      for (var i = 0; i < opts.length; i++) {
        if (opts[i].indexOf('No ') === 0) { skipCount++; } else { activeIndex = i; }
      }
      if (skipCount === optionCount - 1 && activeIndex >= 0) {
        individualPrices[opts[activeIndex]] = v.price;
      }
    });

    fields.forEach(function(field) {
      var noOpts = field.querySelectorAll('.x-variant-picker__option[data-value^="No "]');
      noOpts.forEach(function(el) { individualPrices[el.dataset.value] = 0; });
    });
  }

  function convertToDropdowns() {
    var picker = document.querySelector(PICKER_SELECTOR);
    if (!picker) return;

    var fields = Array.from(picker.querySelectorAll('.x-variant-picker__input'));

    // Product category names for each step
    var stepNames = ['Microbes + Feeder', 'Kelp', 'Compost'];

    fields.forEach(function(field, fieldIndex) {
      var optionEls = Array.from(field.querySelectorAll('.x-variant-picker__option'));
      if (!optionEls.length) return;

      // Hide the radio button grid
      var optionValues = field.querySelector('.x-variant-picker__option-values');
      if (optionValues) optionValues.style.display = 'none';

      var categoryName = stepNames[fieldIndex] || 'Product';

      // Build the dropdown wrapper
      var wrapper = document.createElement('div');
      wrapper.className = 'soilife-dropdown-wrapper';

      var select = document.createElement('select');
      select.className = 'soilife-bundle-select';
      select.setAttribute('data-soilife-dropdown', 'true');

      // Placeholder option (non-selectable)
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Select ' + categoryName + '...';
      placeholder.disabled = true;
      select.appendChild(placeholder);

      // Build product options first, then skip option last
      var skipOption = null;
      optionEls.forEach(function(optEl) {
        var value = optEl.dataset.value;
        var isSkip = value.indexOf('No ') === 0;

        if (isSkip) {
          skipOption = value;
          return; // add it last
        }

        var option = document.createElement('option');
        option.value = value;

        var price = individualPrices[value];
        var badge = OPTION_BADGES[value];

        // Format: "5L — $99.00" with badge text
        // Extract just the size from the value (e.g. "M+F 5L" → "5L")
        var sizePart = value.replace(/^(M\+F|Kelp|Compost)\s*/i, '');
        var text = sizePart;
        if (price !== undefined && price > 0) {
          text += '  ·  ' + formatMoney(price);
        }
        if (badge) {
          text += '  ★ ' + badge.text;
        }
        option.textContent = text;

        select.appendChild(option);
      });

      // Add skip/none option at the end
      if (skipOption) {
        var noneOpt = document.createElement('option');
        noneOpt.value = skipOption;
        noneOpt.textContent = 'None — Add a 2nd item for 6% off, or 3rd for 12% off';
        select.appendChild(noneOpt);
      }

      wrapper.appendChild(select);

      // Insert after the label
      var label = field.querySelector('.x-variant-picker__label, .x-form-label');
      if (label) {
        label.insertAdjacentElement('afterend', wrapper);
      } else {
        field.appendChild(wrapper);
      }

      function updateWrapperState() {
        var val = select.value;
        var isSkip = !val || val.indexOf('No ') === 0;
        if (isSkip) {
          wrapper.classList.add('soilife-dropdown-wrapper--skip');
          wrapper.classList.remove('soilife-dropdown-wrapper--active');
        } else {
          wrapper.classList.remove('soilife-dropdown-wrapper--skip');
          wrapper.classList.add('soilife-dropdown-wrapper--active');
        }
      }

      // Sync dropdown → hidden radio
      select.addEventListener('change', function() {
        var selectedValue = this.value;
        var radios = field.querySelectorAll('input[type="radio"]');
        radios.forEach(function(radio) {
          if (radio.value === selectedValue) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        updateWrapperState();
      });

      updateWrapperState();
    });
  }

  function rearrangeLayout() {
    var descBullets = document.querySelector('#x-zq6zgi94');
    var descText = document.querySelector('#x-y8vy55d3');
    var collapsible = document.querySelector('#x-ivdka5ns');

    if (!descBullets || !descText || !collapsible) return;

    // Get existing Ingredients collapsible to clone its exact structure
    var ingredientsBlock = document.querySelector('#x-6rsawine');
    if (!ingredientsBlock) return;

    // Clone the Ingredients block as a template
    var descBlock = ingredientsBlock.cloneNode(true);
    descBlock.id = 'x-desc-collapsible';
    descBlock.className = 'x-collapsible-content x-element';

    // Replace the title text
    var titleSpan = descBlock.querySelector('.x-collapsible__button > span:first-child');
    if (titleSpan) titleSpan.textContent = 'Description';

    // Replace the content inside the collapsible panel
    var contentWrapper = descBlock.querySelector('.x-collapsible__content-wrapper');
    if (contentWrapper) {
      contentWrapper.innerHTML = '<div class="x-collapsible__content x-layout-auto"></div>';
      var contentInner = contentWrapper.querySelector('.x-collapsible__content');
      contentInner.appendChild(descBullets);
      contentInner.appendChild(descText);
    }

    // Ensure the cloned tab starts collapsed
    var tab = descBlock.querySelector('x-collapsible-tab');
    if (tab) tab.classList.remove('is-open');

    // Insert as first child of the collapsible wrapper
    collapsible.insertBefore(descBlock, ingredientsBlock);

    // Wire up toggle (since Foxify JS already ran before our injection)
    var trigger = descBlock.querySelector('[data-trigger="true"]');
    var panel = contentWrapper;

    if (trigger && panel) {
      panel.style.maxHeight = '0';
      panel.style.overflow = 'hidden';
      panel.style.transition = 'max-height 0.3s ease';

      trigger.addEventListener('click', function() {
        var isOpen = tab.classList.contains('is-open');
        if (isOpen) {
          panel.style.maxHeight = '0';
          tab.classList.remove('is-open');
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          tab.classList.add('is-open');
        }
      });
    }
  }

  function initPricing() {
    var picker = document.querySelector(PICKER_SELECTOR);
    if (!picker) return;

    var jsonScript = picker.querySelector('script[type="application/json"]');
    if (!jsonScript) return;

    var variants;
    try { variants = JSON.parse(jsonScript.textContent); } catch(e) { return; }
    if (!variants || !variants.length) return;

    var fields = Array.from(picker.querySelectorAll('.x-variant-picker__input'));

    // Create running total display
    var totalEl = document.createElement('div');
    totalEl.className = 'bundle-running-total';
    totalEl.innerHTML =
      '<div class="bundle-total-inner">' +
        '<div class="bundle-total-prices">' +
          '<span class="bundle-total-amount"></span>' +
          '<span class="bundle-total-compare"></span>' +
        '</div>' +
        '<span class="bundle-total-savings"></span>' +
      '</div>' +
      '<div class="bundle-microcopy"></div>';

    var buyButton = document.querySelector(BUY_BUTTON_SELECTOR);
    if (buyButton) {
      buyButton.insertAdjacentElement('beforebegin', totalEl);
    } else {
      picker.insertAdjacentElement('afterend', totalEl);
    }

    function getCurrentOptions() {
      return fields.map(function(field) {
        var soiSelect = field.querySelector('select[data-soilife-dropdown]');
        if (soiSelect) return soiSelect.value;
        var fieldType = field.dataset.fieldType;
        if (fieldType === 'button') {
          var checked = field.querySelector('input:checked');
          return checked ? checked.value : '';
        }
        var select = field.querySelector('select');
        return select ? select.value : '';
      });
    }

    function findVariant(options) {
      return variants.find(function(v) {
        return v.options.every(function(opt, i) {
          return options[i] === opt;
        });
      });
    }

    // Store findVariant and getCurrentOptions for the buy button
    window._soilifeBundleFindVariant = findVariant;
    window._soilifeBundleGetOptions = getCurrentOptions;

    function update() {
      var currentOptions = getCurrentOptions();

      // Count active (non-skip) items
      var activeCount = 0;
      currentOptions.forEach(function(opt) {
        if (opt && opt.indexOf('No ') !== 0) activeCount++;
      });

      // Sum individual prices for display
      var subtotal = 0;
      currentOptions.forEach(function(opt) {
        if (opt && opt.indexOf('No ') !== 0) {
          subtotal += individualPrices[opt] || 0;
        }
      });

      var currentVariant = findVariant(currentOptions);
      var totalAmount = totalEl.querySelector('.bundle-total-amount');
      var totalCompare = totalEl.querySelector('.bundle-total-compare');
      var totalSavings = totalEl.querySelector('.bundle-total-savings');
      var microcopy = totalEl.querySelector('.bundle-microcopy');

      if (activeCount > 0) {
        // Calculate discount from individual prices
        var discountPct = 0;
        if (activeCount >= 3) discountPct = 12;
        else if (activeCount >= 2) discountPct = 6;

        var discountAmount = Math.round(subtotal * discountPct / 100);
        var finalTotal = subtotal - discountAmount;

        totalAmount.textContent = formatMoney(finalTotal);

        if (discountPct > 0) {
          totalCompare.textContent = formatMoney(subtotal);
          totalSavings.innerHTML = 'Save ' + formatMoney(discountAmount) + ' <span class="savings-pct">(' + discountPct + '% off)</span>';
          totalSavings.style.display = '';
        } else {
          totalCompare.textContent = '';
          totalSavings.innerHTML = '';
          totalSavings.style.display = 'none';
        }
      } else {
        totalAmount.textContent = '$0.00';
        totalCompare.textContent = '';
        totalSavings.innerHTML = '';
        totalSavings.style.display = 'none';
      }

      // Micro-copy
      if (activeCount > 0) {
        var discountNote = activeCount >= 2 ? 'Bundle discount included in price' : 'Add a 2nd product for 6% off, or 3rd for 12% off';
        microcopy.innerHTML = activeCount + ' item' + (activeCount > 1 ? 's' : '') + ' in your bundle &nbsp;\u00b7&nbsp; ' + discountNote;
      } else {
        microcopy.innerHTML = 'Select products above to start your bundle';
      }
    }

    update();

    picker.addEventListener('change', function() {
      setTimeout(update, 50);
    });

    if (window.Foxify && window.Foxify.Events) {
      var productId = picker.dataset.productId;
      if (productId) {
        Foxify.Events.on(productId + '__VARIANT_CHANGE', function() {
          setTimeout(update, 50);
        });
      }
    }
  }

  function overrideBuyButton() {
    var buyButton = document.querySelector(BUY_BUTTON_SELECTOR);
    if (!buyButton) return;

    var picker = document.querySelector(PICKER_SELECTOR);
    if (!picker) return;

    var jsonScript = picker.querySelector('script[type="application/json"]');
    if (!jsonScript) return;

    var variants;
    try { variants = JSON.parse(jsonScript.textContent); } catch(e) { return; }

    var fields = Array.from(picker.querySelectorAll('.x-variant-picker__input'));

    // Prevent Foxify's native form submission
    var form = buyButton.closest('form');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();
      }, true);
    }

    buyButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Find the matching bundle variant
      var currentOptions = fields.map(function(field) {
        var soiSelect = field.querySelector('select[data-soilife-dropdown]');
        if (soiSelect) return soiSelect.value;
        var checked = field.querySelector('input:checked');
        return checked ? checked.value : '';
      });

      var matchedVariant = variants.find(function(v) {
        return v.options.every(function(opt, i) {
          return currentOptions[i] === opt;
        });
      });

      if (!matchedVariant) return;

      buyButton.disabled = true;
      var originalText = buyButton.textContent || buyButton.innerText;
      buyButton.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: matchedVariant.id, quantity: 1 }] })
      })
      .then(function(res) {
        if (!res.ok) { throw new Error('cart/add ' + res.status); }
        return res.json();
      })
      .then(function() {
        // Guaranteed feedback: the header's count bubble isn't in the DOM on an
        // empty cart and our custom add doesn't trigger the theme's re-render,
        // so updating it in place is unreliable (customer thinks nothing
        // happened). Send them to the cart, where they always see the bundle.
        buyButton.textContent = 'Added! \u2713';
        window.location.href = '/cart';
      })
      .catch(function(err) {
        if (window.console) console.error('[soilife-atc] add failed', err);
        buyButton.textContent = 'Error \u2014 try again';
        buyButton.disabled = false;
      });
    }, true);
  }

  function fixFaqSection() {
    var faqGrid = document.querySelector('#x-6ul9fj94');
    if (!faqGrid) return;

    // Override Foxify's fixed height on the FAQ grid
    faqGrid.style.setProperty('height', 'auto', 'important');
    faqGrid.style.setProperty('min-height', 'auto', 'important');

    // Fix heading cell
    var headingCell = document.querySelector('#x-4lw1d9so');
    if (headingCell) {
      headingCell.style.setProperty('height', 'auto', 'important');
    }

    // Fix both FAQ cells — align to top
    var leftFaq = document.querySelector('#x-mnj8uz82');
    var rightFaq = document.querySelector('#x-eyvuj83u');

    [leftFaq, rightFaq].forEach(function(cell) {
      if (!cell) return;
      cell.style.setProperty('height', 'auto', 'important');
      cell.style.setProperty('align-items', 'flex-start', 'important');
      cell.style.setProperty('justify-content', 'flex-start', 'important');
    });
  }

  function fixProductGridSection() {
    // Only fix on tablet/mobile (≤ 1099px)
    if (window.innerWidth > 1099) return;

    var section = document.querySelector('#x-b149iew6');
    if (!section) return;

    // Fix section min-height
    section.style.setProperty('min-height', 'auto', 'important');
    section.style.setProperty('height', 'auto', 'important');

    // Fix the grid container — switch to flex column to prevent overlap
    var container = section.querySelector('.x-container-custom');
    if (container) {
      container.style.setProperty('display', 'flex', 'important');
      container.style.setProperty('flex-direction', 'column', 'important');
    }

    // Fix the heading — place it first, full width, no overlap
    var heading = document.querySelector('#x-7bisbnvi');
    if (heading) {
      heading.style.setProperty('width', '100%', 'important');
      heading.style.setProperty('margin', '0 0 16px 0', 'important');
      heading.style.setProperty('justify-self', 'center', 'important');
      heading.style.setProperty('align-self', 'start', 'important');
      heading.style.setProperty('text-align', 'center', 'important');
      heading.style.setProperty('order', '-1', 'important');
    }

    // Fix the product list — remove negative margins
    var productList = document.querySelector('#x-0gildmkd');
    if (productList) {
      productList.style.setProperty('margin', '0', 'important');
      productList.style.setProperty('align-self', 'stretch', 'important');
      productList.style.setProperty('justify-self', 'stretch', 'important');
      productList.style.setProperty('width', '100%', 'important');
    }
  }

  function injectClarityText() {
    if (document.querySelector('.soilife-clarity-text')) return;

    // Insert before the Description accordion (collapsible section)
    var accordion = document.querySelector('#x-ivdka5ns');
    if (!accordion) return;

    var clarity = document.createElement('div');
    clarity.className = 'soilife-clarity-text';
    clarity.innerHTML =
      '<ul class="soilife-clarity-text__list">' +
        '<li>For <strong>5L</strong> Soil Microbes and Feeder purchases, you will receive 1x 5L Soil Microbe and 1x 1L of Microbe Feeder Concentrate.</li>' +
        '<li>For <strong>20L</strong> Soil Microbes and Feeder purchases, you will receive 1x 20L Soil Microbe and 1x 5L Microbe Feeder Concentrate (4x strength).</li>' +
      '</ul>' +
      '<ul class="soilife-clarity-text__list">' +
        '<li>Concentrate feeder mix = <strong>10ml</strong> of microbes and <strong>2.5ml</strong> of Feeder per 1m2.</li>' +
        '<li>For 1 and 2 litre Microbe and Feeder mix even parts: <strong>10ml</strong> Microbes and <strong>10ml</strong> Feeder.</li>' +
      '</ul>' +
      '<p class="soilife-clarity-text__note">This means we can keep the postage costs lower, and we also use just a little bit less plastic. Instructions are always on the Microbe bottle.</p>';

    accordion.insertAdjacentElement('beforebegin', clarity);
  }

  function replaceTwoPartSection() {
    var oldSection = document.getElementById('x-q8ga3h6q');
    if (!oldSection || document.querySelector('.soilife-two-part') || !window.soilifeTwoPartImgs) return;

    var panels = [
      { alt: 'The power packed two-part formula - Part A: Soil Microbes, Part B: Microbes Feeder', color: 'purple' },
      { alt: 'What Is Compost Microbes? A concentrated blend of beneficial bacteria and fungi', color: 'orange' },
      { alt: 'What Is Kelp Power? A premium seaweed extract sourced from Australian kelp', color: 'green' }
    ];

    var wrapper = document.createElement('div');
    wrapper.className = 'soilife-two-part';
    window.soilifeTwoPartImgs.forEach(function(url, i) {
      wrapper.innerHTML +=
        '<div class="soilife-two-part__panel soilife-two-part__panel--' + panels[i].color + '">' +
          '<img src="' + url + '" alt="' + panels[i].alt + '" loading="' + (i === 0 ? 'eager' : 'lazy') + '">' +
        '</div>';
    });

    oldSection.insertAdjacentElement('afterend', wrapper);
  }

  /* FAQ section now handled by soilife-faq-shared.js */

  function injectSocialProofBar() {
    var productSection = document.querySelector('#x-s4qcim0s');
    if (!productSection) return;
    if (document.querySelector('.soilife-social-proof')) return; // already injected

    var bar = document.createElement('div');
    bar.className = 'soilife-social-proof';
    bar.innerHTML =
      '<span class="soilife-social-proof__stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span>' +
      '<strong>227 Reviews</strong>' +
      '<span class="soilife-social-proof__sep">|</span>' +
      '<span>1800+ Happy Customers</span>' +
      '<span class="soilife-social-proof__sep">|</span>' +
      '<span>Scientifically Proven</span>' +
      '<span class="soilife-social-proof__sep">|</span>' +
      '<span>14+ Years in Development</span>';

    productSection.insertAdjacentElement('afterend', bar);
  }

  function enhanceSocialProof() {
    // Find the existing "★★★★★ 227 Reviews | 1800+ Happy Customers" element and enhance it
    var reviewEls = document.querySelectorAll('#x-s4qcim0s .x-text, #x-s4qcim0s .x-rte');
    reviewEls.forEach(function(el) {
      if (el.textContent && el.textContent.indexOf('Reviews') !== -1 && el.textContent.indexOf('Happy') !== -1) {
        el.className += ' soilife-social-proof';
        el.innerHTML =
          '<span class="soilife-social-proof__stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span>' +
          '<strong>227 Reviews</strong>' +
          '<span class="soilife-social-proof__sep">|</span>' +
          '<span>1800+ Happy Customers</span>' +
          '<span class="soilife-social-proof__sep">|</span>' +
          '<span>Scientifically Proven</span>' +
          '<span class="soilife-social-proof__sep">|</span>' +
          '<span>14+ Years in Development</span>';
      }
    });
  }

  function reorderSections() {
    // Move testimonials (#x-dm87cj9j) right after the product section
    var productSection = document.querySelector('#x-s4qcim0s');
    var testimonials = document.querySelector('#x-dm87cj9j');

    // Order: product → social proof bar → testimonials
    var socialBar = document.querySelector('.soilife-social-proof');
    if (productSection && testimonials) {
      if (socialBar) {
        productSection.insertAdjacentElement('afterend', socialBar);
        socialBar.insertAdjacentElement('afterend', testimonials);
      } else {
        productSection.insertAdjacentElement('afterend', testimonials);
      }

      // Reinitialize Swiper after DOM move
      setTimeout(function() {
        var swiperEl = testimonials.querySelector('.swiper, [data-swiper]');
        if (swiperEl && swiperEl.swiper) {
          swiperEl.swiper.update();
        }
      }, 200);
    }

    // Forcefully remove hidden sections from DOM
    // Include wrapper sections that have colored backgrounds
    var hiddenIds = [
      'x-o267m4z4', // orphaned testimonials heading (green bg)
      'x-lfjiui8e', // use cases carousel (has bg image)
      'x-yhjend1t', // key features grid
      'x-dqukfrq8', // additional details (blue/purple bg!)
      'x-wwawjjvk', // summary CTA
      'x-x5yh2yki', // FAQ WRAPPER section (dark green bg!) — wraps x-6ul9fj94
      'x-6ul9fj94', // Foxify FAQ inner
      'x-b149iew6'  // Foxify product grid
    ];
    hiddenIds.forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.remove();
    });
  }

  function injectDiscountMessaging() {
    var picker = document.querySelector(PICKER_SELECTOR);

    // --- 3a: Banner above bundle picker ---
    var banner = document.createElement('div');
    banner.className = 'soilife-discount-banner';
    banner.innerHTML =
      '<div class="soilife-discount-banner__inner">' +
        '<span class="soilife-discount-banner__icon">&#127873;</span>' +
        '<div class="soilife-discount-banner__text">' +
          '<strong>Bundle &amp; save even more!</strong>' +
          '<span class="soilife-discount-banner__tiers">' +
            '<span class="soilife-discount-tier">Buy 2 items &rarr; <strong>6% off</strong></span>' +
            '<span class="soilife-discount-tier__sep">|</span>' +
            '<span class="soilife-discount-tier">Buy 3 items &rarr; <strong>12% off</strong></span>' +
          '</span>' +
        '</div>' +
      '</div>';

    if (picker) {
      picker.insertAdjacentElement('beforebegin', banner);
    }

    // --- 3b: Sticky announcement bar --- (disabled: global shipping bar handles this)
    if (false && !sessionStorage.getItem('soilife_sticky_dismissed')) {
      var stickyBar = document.createElement('div');
      stickyBar.className = 'soilife-sticky-bar';
      stickyBar.innerHTML =
        '<div class="soilife-sticky-bar__inner">' +
          '<span class="soilife-sticky-bar__text">' +
            'Bundle &amp; Save: <strong>6% off 2 items</strong> or <strong>12% off 3 items</strong> &mdash; applied automatically at checkout' +
          '</span>' +
          '<button class="soilife-sticky-bar__close" aria-label="Dismiss">&times;</button>' +
        '</div>';

      document.body.insertAdjacentElement('afterbegin', stickyBar);

      // Compensate for sticky bar height
      var barHeight = stickyBar.offsetHeight || 44;
      document.body.style.paddingTop = barHeight + 'px';

      stickyBar.querySelector('.soilife-sticky-bar__close').addEventListener('click', function() {
        stickyBar.style.transform = 'translateY(-100%)';
        document.body.style.paddingTop = '';
        sessionStorage.setItem('soilife_sticky_dismissed', '1');
        setTimeout(function() { stickyBar.remove(); }, 300);
      });
    }

  }

  function preSelectDefaults() {
    var picker = document.querySelector(PICKER_SELECTOR);
    if (!picker) return;

    var fields = Array.from(picker.querySelectorAll('.x-variant-picker__input'));
    var defaults = ['M+F 5L', 'No Kelp', 'No Compost'];

    fields.forEach(function(field, index) {
      if (index >= defaults.length) return;
      var target = defaults[index];

      // Set dropdown value and trigger sync
      var soiSelect = field.querySelector('select[data-soilife-dropdown]');
      if (soiSelect) {
        soiSelect.value = target;
        soiSelect.dispatchEvent(new Event('change', { bubbles: false }));
      }

      // Also set the hidden radio directly as fallback
      var options = field.querySelectorAll('.x-variant-picker__option');
      options.forEach(function(opt) {
        if (opt.dataset.value === target) {
          var radio = opt.querySelector('input[type="radio"]');
          if (radio && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    });
  }

  function injectAlsoBought() {
    var picker = document.querySelector(PICKER_SELECTOR);

    // Map picker step index to product handle
    var stepProducts = [
      { handle: 'soil-microbes-feeder', label: 'Soil Microbes + Feeder', skipPrefix: 'No M' },
      { handle: 'kelp-power', label: 'Kelp Power', skipPrefix: 'No Kelp' },
      { handle: 'compost-microbes', label: 'Compost Microbes', skipPrefix: 'No Compost' }
    ];

    // Fetch all product data upfront
    var fetches = stepProducts.map(function(sp) {
      return fetch('/products/' + sp.handle + '.js').then(function(r) { return r.json(); });
    });

    Promise.all(fetches).then(function(products) {
      // Store product data keyed by handle
      var productData = {};
      products.forEach(function(p) { productData[p.handle] = p; });

      // Create section container
      var section = document.createElement('section');
      section.className = 'soilife-also-bought';

      // Insert after the product section
      var productSection = document.querySelector('.x-main .x-section:first-child');
      if (productSection) {
        productSection.insertAdjacentElement('afterend', section);
      } else {
        document.querySelector('.x-main').appendChild(section);
      }

      function getActiveSteps() {
        if (!picker) return [true, false, false];
        var fields = Array.from(picker.querySelectorAll('.x-variant-picker__input'));
        return fields.map(function(field) {
          var fieldType = field.dataset.fieldType;
          var val = '';
          if (fieldType === 'button') {
            var checked = field.querySelector('input:checked');
            val = checked ? checked.value : '';
          } else {
            var sel = field.querySelector('select');
            val = sel ? sel.value : '';
          }
          return val && val.indexOf('No ') !== 0;
        });
      }

      function renderSection() {
        var activeSteps = getActiveSteps();
        var activeCount = activeSteps.filter(Boolean).length;

        // Determine which products to suggest (ones NOT currently selected)
        var missing = [];
        var selected = [];
        stepProducts.forEach(function(sp, i) {
          var p = productData[sp.handle];
          if (!p) return;
          if (!activeSteps[i]) {
            missing.push(p);
          } else {
            selected.push(p);
          }
        });

        // Build messaging
        var title = '';
        var subtitle = '';

        if (activeCount >= 3) {
          title = 'You\'re Getting the Best Deal!';
          subtitle = 'All 3 products selected &mdash; <strong>12% off</strong> applies at checkout';
          missing = [];
          stepProducts.forEach(function(sp) {
            var p = productData[sp.handle];
            if (p) missing.push(p);
          });
        } else if (activeCount === 2) {
          title = 'Complete Your Bundle';
          subtitle = 'Add <strong>' + missing[0].title + '</strong> to unlock <strong>12% off</strong> your entire order';
        } else if (activeCount === 1) {
          title = 'Frequently Bought Together';
          if (missing.length === 2) {
            subtitle = 'Add one more for <strong>6% off</strong>, or both for <strong>12% off</strong>';
          } else {
            subtitle = 'Add another product for <strong>6% off</strong>';
          }
        } else {
          title = 'Popular Products';
          subtitle = 'Bundle 2+ items for up to <strong>12% off</strong> + shipping discounts!';
        }

        var cards = missing.map(function(p) {
          var img = p.images[0] || '';
          var price = formatMoney(p.price_min);
          var url = '/products/' + p.handle;
          var isSelected = activeCount >= 3;
          return (
            '<a href="' + url + '" class="soilife-also-bought__card' + (isSelected ? ' soilife-also-bought__card--selected' : '') + '">' +
              (isSelected ? '<span class="soilife-ab-card-check">&#10003;</span>' : '') +
              '<div class="soilife-also-bought__img-wrap">' +
                '<img src="' + img + '" alt="' + p.title + '" loading="lazy">' +
              '</div>' +
              '<div class="soilife-also-bought__info">' +
                '<span class="soilife-also-bought__name">' + p.title + '</span>' +
                '<span class="soilife-also-bought__price">From ' + price + '</span>' +
              '</div>' +
            '</a>'
          );
        }).join('');

        section.innerHTML =
          '<h2 class="soilife-also-bought__title">' + title + '</h2>' +
          '<div class="soilife-also-bought__subtitle">' + subtitle + '</div>' +
          '<div class="soilife-also-bought__grid">' + cards + '</div>';
      }

      renderSection();

      // Re-render when variant changes
      if (picker) {
        picker.addEventListener('change', function() {
          setTimeout(renderSection, 80);
        });
        if (window.Foxify && window.Foxify.Events) {
          var productId = picker.dataset.productId;
          if (productId) {
            Foxify.Events.on(productId + '__VARIANT_CHANGE', function() {
              setTimeout(renderSection, 80);
            });
          }
        }
      }
    }).catch(function() {});
  }

  function init() {
    buildIndividualPrices();
    convertToDropdowns();
    preSelectDefaults();
    rearrangeLayout();

    initPricing();
    overrideBuyButton();

    injectDiscountMessaging();
    injectSocialProofBar();
    reorderSections();
    // injectAlsoBought();
    injectClarityText();
    replaceTwoPartSection();
    /* FAQ now handled by soilife-faq-shared.js */
    fixProductGridSection();
  }

  // ── Robust readiness ────────────────────────────────────────────────
  // Foxify renders the picker asynchronously. A fixed 500ms timer was
  // unreliable on slow mobile/networks: if the picker wasn't ready, the
  // dropdowns + buy-button override never attached and Add-to-Cart silently
  // did nothing. Instead, wait until the picker, its option fields AND the
  // buy button all exist, then init once. Observer catches it ASAP; the poll
  // is a fallback; both are capped so they can't run forever.
  var _inited = false;
  function _ready() {
    var picker = document.querySelector(PICKER_SELECTOR);
    if (!picker) return false;
    if (!picker.querySelector('.x-variant-picker__input')) return false;
    if (!document.querySelector(BUY_BUTTON_SELECTOR)) return false;
    return true;
  }
  function _boot() {
    if (_inited) return;
    if (!_ready()) return;
    _inited = true;
    try { init(); }
    catch (e) { if (window.console) console.error('[soilife-atc] init failed', e); }
  }
  function startWaiting() {
    _boot();
    if (_inited) return;
    var tries = 0;
    var poll = setInterval(function() {
      tries++;
      _boot();
      if (_inited || tries > 150) clearInterval(poll); // ~15s @ 100ms
    }, 100);
    var obs = new MutationObserver(function() {
      _boot();
      if (_inited) { obs.disconnect(); clearInterval(poll); }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function() { obs.disconnect(); }, 16000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWaiting);
  } else {
    startWaiting();
  }
})();
